import memoize from 'lodash/memoize';
import { auth } from 'services/auth';
import { CreateUser } from 'shared/types/endpoints';
import {
  convertPhoneNumberToE164,
  testE164Phone,
} from 'shared/utils/functions';
import { isEmail, isWeakPassword } from 'utils/validators';

type ConsumerSignupError = {
  email?: string;
  password?: string;
  zipcode?: string;
  mobile_phone?: string;
  first_name?: string;
  last_name?: string;
};

const isEmailAvailable = memoize(auth.isEmailAvailable);

export default async function consumerSignupFormV2Validate(
  values: CreateUser,
): Promise<ConsumerSignupError> {
  const errors: ConsumerSignupError = {};
  const email = values.email?.trim();

  if (!values.first_name) {
    errors.first_name = 'First name is required';
  }

  if (!values.last_name) {
    errors.last_name = 'Last name is required';
  }

  if (!email) {
    errors.email = 'Email required';
  } else if (!isEmail(email)) {
    errors.email = 'Invalid email address';
  } else {
    try {
      if (!(await isEmailAvailable(email))) {
        errors.email =
          "We're sorry, it looks like that email address is already in use. Please use a login form.";
      }
    } catch (e) {
      errors.email = e.message;
    }
  }

  if (!values.password) {
    errors.password = 'Password is required';
  } else if (values.password.length < 8) {
    errors.password = 'Password length should be 8 symbols or greater';
  } else if (isWeakPassword(values.password)) {
    errors.password =
      'Password is weak. Please use uppercase, lowercase letters and numbers';
  } else if (values.password.trim().length !== values.password.length) {
    errors.password = 'Password should not contain leading or trailing spaces';
  }

  if (
    !values.mobile_phone ||
    !testE164Phone(convertPhoneNumberToE164(values.mobile_phone))
  ) {
    errors.mobile_phone = 'Incorrect phone number';
  }

  return errors;
}
